import {
  DepositCaptureStrategy,
  DepositPaymentMode,
} from '@principle-theorem/principle-core/interfaces';

const legacyChargePaymentMode = 'autoCapture';
const legacyImmediateChargeStrategy = 'captureBeforeExpiry';
const legacyHoldStrategy = 'preAuthorisationOnly';

/**
 * Translates branch-only persisted deposit values so stale development data can
 * still cross runtime boundaries after the corresponding enum members vanish.
 */
export class LegacyDepositValueNormalization {
  /**
   * Keeps old automatic-capture settings readable without preserving automatic
   * capture semantics in the active payment-mode enum.
   */
  static paymentMode(value: DepositPaymentMode): DepositPaymentMode;
  static paymentMode(value: unknown): unknown;
  static paymentMode(value: unknown): unknown {
    return value === legacyChargePaymentMode
      ? DepositPaymentMode.Charge
      : value;
  }

  /**
   * Maps removed capture strategies to the closest safe surviving behaviour at
   * the boundary where stale development settings enter the application.
   */
  static captureStrategy(value: DepositCaptureStrategy): DepositCaptureStrategy;
  static captureStrategy(value: unknown): unknown;
  static captureStrategy(value: unknown): unknown {
    if (value === legacyImmediateChargeStrategy) {
      return DepositCaptureStrategy.ChargeOnBookingRequest;
    }
    if (value === legacyHoldStrategy) {
      return DepositCaptureStrategy.CaptureOnCancellationOrReschedule;
    }
    return value;
  }
}
